import { render } from "./SearchClientModal.vue?vue&type=template&id=48d0d202&scoped=true"
import script from "./SearchClientModal.vue?vue&type=script&lang=js"
export * from "./SearchClientModal.vue?vue&type=script&lang=js"

import "./SearchClientModal.vue?vue&type=style&index=0&id=48d0d202&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48d0d202"]])

export default __exports__